<template>
  <div
    class="selected-items-block-reset"
    @click="$emit('reset')"
  >
    <div class="selected-items-block-reset__cross">
      <MIcon
        :icon="iconCross"
      />
    </div>
    <div class="selected-items-block-reset__text">
      {{ _getTr('reset_all') }}
    </div>
  </div>
</template>

<script>
  import MIcon from 'components/Design/MIcon';
  import iconCross from 'assets/icons/cross.svg';

  export default {
    name: 'SelectedItemsBlockReset',
    components: {MIcon},
    data () {
      return {
        iconCross
      };
    }
  };
</script>

<style>
  .selected-items-block-reset {
    font-size: 12px;

    color: var(--panel-text-color);

    cursor: pointer;

    display: flex;

    align-items: center;
  }

  .selected-items-block-reset:hover {
    color: var(--secondary-text-color);
  }

  .selected-items-block-reset__cross {
    width: 14px;
    height: 14px;

    margin-right: 4px;
  }
</style>
